import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import DocumentTitle from 'react-document-title'
import CSSModules from 'react-css-modules'
import { Relayout, RelayoutItem, RelayoutWrapper } from 'relayout'

import { loadSetupform, loadEventTypes, submitSetupform } from 'actions/setupform'
import SetupformBreadcrumbProgress, { BREADCRUMB_REVIEW } from 'components/setupform-breadcrumb-progress'
import ErrorMessage from 'components/error-message'
import { EventGroupPurchaseTypes } from 'constants/eventgroup-constants'
import { getPartnerUrl } from 'utils/urls'
import SetupformSummary from 'components/setupform-summary'
import SetupformVoucherSummary from 'components/setupform-summary/setupform-voucher-summary'
import { getSetupform, getVenue, getCategoryName } from 'selectors/entities'
import { getGroupedInstances, isVoucher } from 'selectors/setupform'

import styles from './setupform-summary-page.css'

import TimeOutLogo from '../../../assets/icons/to-logo-black.svg'
import ArrowRightIcon from '../../../assets/icons/arrow-right.svg'

export class SetupformSummaryPage extends Component {

  constructor(props) {
    super(props)

    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentWillMount() {
    this.props.loadSetupform(this.props.setupformId)
    this.props.loadEventTypes()
  }

  handleSubmit() {
    if (this.isSetupformInReview()) {
      this.props.history.push(getPartnerUrl(this.props.partnerId))
    } else {
      this.props.submitSetupform(this.props.setupformId)
    }
  }

  isSetupformInReview() {
    const { setupform } = this.props

    return setupform && setupform.reviewStatus === 'yplan_review'
  }

  renderUserInstruction() {
    if (!this.props.setupform) {
      return null
    }

    const purchaseType = this.props.isVoucher ? 'product' : 'event'

    if (this.props.setupform.reviewStatus === 'yplan_review') {
      return (
        <div styleName="user-instruction">
          <p>This {purchaseType} has been submitted for review.</p>
          <p>If you would like to make changes at this stage please contact your account manager.</p>
        </div>
      )
    }

    return null
  }

  renderSummary() {
    if (this.props.setupform.purchaseType === EventGroupPurchaseTypes.VOUCHER) {
      return this.renderVoucherSummary()
    }

    return this.renderEventSummary()
  }

  renderEventSummary() {
    return (
      <RelayoutWrapper>
        <Relayout align="center">
          <RelayoutItem sm="10">

            {this.renderUserInstruction()}

            <SetupformSummary
              setupform={this.props.setupform}
              instances={this.props.instances}
              venue={this.props.venue}
            />

          </RelayoutItem>
        </Relayout>
      </RelayoutWrapper>
    )
  }

  renderVoucherSummary() {
    return (
      <RelayoutWrapper>
        <Relayout align="center">
          <RelayoutItem sm="10">

            <div styleName="user-instruction">
              {this.renderUserInstruction()}
            </div>

            <SetupformVoucherSummary
              setupform={this.props.setupform}
              instanceGroups={this.props.setupform.instanceGroups}
              categoryName={this.props.categoryName}
              venue={this.props.venue}
              imageUrl={this.props.imageUrl}
            />
          </RelayoutItem>
        </Relayout>
      </RelayoutWrapper>
    )
  }

  render() {
    return (
      <DocumentTitle title={'Ecommerce Portal - Time Out - Setupform'}>
        <div styleName="page">

          <div styleName="header">
            <a href={getPartnerUrl(this.props.partnerId)}>
              <div styleName="logo">
                <TimeOutLogo styleName="logo-icon" />
              </div>
            </a>
            <SetupformBreadcrumbProgress
              isVoucher={this.props.isVoucher}
              currentStep={BREADCRUMB_REVIEW}
            />
            <button
              styleName="next"
              onClick={this.handleSubmit}
            >
              {this.isSetupformInReview()
                ? 'Close'
                : 'Submit for approval'
              }
              <ArrowRightIcon styleName="next-icon" />
            </button>
          </div>

          <ErrorMessage isFixed isSmall />

          { this.props.setupform ? this.renderSummary() : null }

        </div>
      </DocumentTitle>
    )
  }
}

SetupformSummaryPage.propTypes = {
  instances: PropTypes.array,
  loadSetupform: PropTypes.func,
  loadEventTypes: PropTypes.func,
  partnerId: PropTypes.string,
  setupform: PropTypes.object,
  setupformId: PropTypes.string,
  isVoucher: PropTypes.bool,
  submitSetupform: PropTypes.func,
  venue: PropTypes.object,
  history: PropTypes.object,
  categoryName: PropTypes.string,
  imageUrl: PropTypes.string,
}

const mapStateToProps = (state, ownProps) => {
  const setupform = getSetupform(ownProps.params.setupformId)(state)
  const categoryName = (setupform && getCategoryName(setupform.eventTypeId)(state))

  return {
    categoryName: categoryName || '',
    imageUrl: state.pages.setupformPage.imagePreview,
    history: ownProps.history,
    ...ownProps.params,
    setupform,
    setupformPurchaseType: state.entities.setupforms
      && state.entities.setupforms[ownProps.params.setupformId]
      && state.entities.setupforms[ownProps.params.setupformId].purchaseType,
    instances: setupform && getGroupedInstances(ownProps.params.setupformId)(state),
    isVoucher: isVoucher(ownProps.params.setupformId)(state),
    venue: setupform && getVenue(setupform.venue)(state),
  }
}

const mapDispatchToProps = { loadSetupform, loadEventTypes, submitSetupform }

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(SetupformSummaryPage, styles))



/** WEBPACK FOOTER **
 ** ./src/containers/setupform-summary-page/setupform-summary-page.js
 **/